import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Compass, ArrowRight, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* Compact "Your next step" nudge shown on the applicant home (ChatPage). */
export const RoadmapNudge = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [data, setData] = useState(null);

  useEffect(() => {
    const config = { withCredentials: true, headers: token ? { Authorization: `Bearer ${token}` } : {} };
    axios.get(`${API}/roadmap`, config).then((r) => setData(r.data)).catch(() => setData(null));
  }, [token]);

  if (!data) return null;

  const go = () => navigate("/roadmap");
  const pct = data.progress.total ? Math.round((data.progress.done / data.progress.total) * 100) : 0;

  return (
    <button onClick={go} data-testid="roadmap-nudge"
      className="w-full text-left group card-flat px-5 py-3.5 flex items-center gap-4 hover:border-equal hover:shadow-sm transition-all">
      <span className="w-9 h-9 rounded-[10px] bg-mint grid place-items-center flex-none">
        {data.finished ? <Check className="w-4 h-4 text-equal-dark" /> : <Compass className="w-4 h-4 text-equal-dark" />}
      </span>
      <div className="min-w-0 flex-1">
        <p className="eyebrow text-equal-dark">
          {data.finished ? "Property roadmap · complete" : !data.business_type ? "Property roadmap" : "Your next step"}
        </p>
        <p className="text-ink font-semibold text-sm truncate mt-0.5">
          {data.finished
            ? "Space secured — see your finished roadmap"
            : !data.business_type
              ? "Start your step-by-step guide to finding and securing a space"
              : (data.next_step && data.next_step.task.title)}
        </p>
        {data.business_type && !data.finished && (
          <div className="mt-2 flex items-center gap-2">
            <div className="h-1.5 w-28 rounded-full bg-line overflow-hidden">
              <div className="h-full bg-equal rounded-full" style={{ width: `${pct}%` }} />
            </div>
            <span className="font-mono text-[10.5px] text-mute">{data.progress.done}/{data.progress.total}</span>
          </div>
        )}
      </div>
      <span className="btn-ghost btn-sm flex-none group-hover:border-equal" data-testid="roadmap-nudge-open">
        {!data.business_type ? "Start" : "Open roadmap"} <ArrowRight className="w-3.5 h-3.5" />
      </span>
    </button>
  );
};

export default RoadmapNudge;
